 $(document).ready(function () {

  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {

    quick_view();

  })
});
function quick_view(data__get_handel) {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle =  data__get_handel.getAttribute('data-handle')
  var quick_node_js = data__get_handel.getAttribute('quick-node-js')
  let node_qtty_js_x = data__get_handel.getAttribute('quick-qyyt-js')

   //   var product_class =  data__get_handel.getAttribute('class')
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      console.log(product)
      var title = product.title;
      var type = product.type;
      var price = 0;

      var original_price = 0;

      var desc = product.description;

      var images = product.images;

      var variants = product.variants;

      var options = product.options;

      var url = '/products/' + product_handle;

      $('.qv-product-title').text(title);

      $('.qv-product-type').text(type);
      var title = desc;
      
      var shortText = jQuery.trim(title).substring(0, 10).split(" ").slice(0, -1).join(" ") + "...";
      $('.qv-product-description').html(shortText);

      $('.view-product').attr('href', url);
      
      var imageCount = $(images).length; 
        // console.log("imageCount",)
      $(images).each(function (i, image) {
        if (i == imageCount-1) {
          console.log('imageCount-1')
          var image_embed = '<div class="djieyet"><img src="' + image + '" class="lazyload" data-src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

           $('.qv-product-images').slick({

            'dots': false,
            'infinite': false,
            'arrows': true,
   
            'respondTo': 'min',

            'useTransform': false

          }).css('opacity', '1');
          
        } else {
 
          image_embed = '<div class="hidden_Image"><img src="' + image + '" class="lazyload" data-src="' + image + '"></div>';

          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
 
        }

      });


      $(options).each(function (i, option) {
 //console.log(option.name)
        var opt = option.name;

        var selectClass = '.option.' + opt.toLowerCase();

        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><ul class="option-' + i + ' option ' + opt.toLowerCase() + '"></ul></div>');

        $(option.values).each(function (i, value) {

          $('.option.' + opt.toLowerCase()).append('<li value="' + value + '">' + value + '</li>');

        });

      });
        setTimeout(()=>{
let value_get = document.querySelectorAll('ul li[value]')
         $(variants).each(function(i,v){

for(let i=0;i<value_get.length;i++){
  if(value_get[i].innerHTML == v.title ){
              // console.log(v.id,"----",v.title)
 // console.log(v.available)
    value_get[i].setAttribute('v_id',v.id)
     value_get[i].setAttribute('v_available',v.available)
    // value_get[i].classList.add(v.available)
  }
}
         })

          let v_get = document.querySelectorAll('[v_id]')
          var flagss = 0  
for(let i=0;i<v_get.length;i++){

    v_get[i].addEventListener('click',function(){
     
      if(v_get[i].getAttribute('v_available') == 'true'){
         console.log(v_get[i].getAttribute('v_available'))
        let v_id =   v_get[i].getAttribute('v_id')
         let qty_js_q =   v_get[i].getAttribute('qty_js_q')
 $('.addTocart_submit [name="id"]').val(v_id)
     let falses =   v_get[i].getAttribute('v_available')
      if(falses != 'false'){
        v_get[i].setAttribute('class','active-size')
        $('.qv-add-button').removeAttr('disabled')
         $('.qv-add-button').val('ADD TO CART')
$(v_get[i]).siblings().attr('class','')
      }

   $('[quantity_qc]').attr('quantity_f',qty_js_q)
 document.querySelector('.small-error').style.display = 'none'
      document.querySelector('[quantity_f]').value = 1;
   }
    var set_pls_btn =   v_get[i].getAttribute('v_available')
      $('[plusbtn]').attr('v_available_q',set_pls_btn)
      $('[quantity_qc]').attr('v_available_q',set_pls_btn)
      $('[minusbtn]').attr('v_available_q',set_pls_btn)
      })
  var arr1 = v_get[i].getAttribute('v_available')
 console.log(arr1) ;
if(arr1 == 'true' || arr1 == true){
flagss = 1
}  
}
   if (document.querySelector('[v_id]') != null){       
    if(flagss == 0){
    $('.qv-add-button').val('SOLD OUT')
    }else{
    $('.qv-add-button').val('ADD TO CART')
    }
   }

//  var js_test = $('.option-selection-size')
// if(js_test.length > 1){
// for(let i=0;i<js_test.length-1;i++){
//     js_test[i].remove()
// }
//  $('.qv-product-options').append('<img src="https://www.svgrepo.com/download/41953/loading.svg" jsaction="load:XAeZkd;" jsname="HiaYvf" class="n3VNCb pT0Scc KAlRDb" alt="Loading Vector SVG Icon (15) - SVG Repo" data-noaft="1" style="width: 96px; height: 96px; margin: 0px;">')  
// }else if(js_test.length == 1){
//   setTimeout(()=>{
//   $('.option-selection-size').css('display','block') 
//     },3000)
// }

  },1000)

      
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {

          $('.qv-add-button').prop('disabled', true).val('Sold Out');

          $('.qv-add-to-cart').hide();

          $('.qv-product-price').text('Sold Out').show();

          return true

        } else {

          price = parseFloat(v.price / 100).toFixed(2);

          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

          $('.qv-product-price').text('Rs. ' + price);

          if (original_price > 0) {

            $('.qv-product-original-price').text('Rs. ' + original_price).show();

          } else {

            $('.qv-product-original-price').hide();
          }

          $('ul.option-0').val(v.option1);

          $('ul.option-1').val(v.option2);

          $('ul.option-2').val(v.option3);

          return false

        }

      });

    });

 

    $(document).on("click", "#quick-view ul>li", function () {

      var selectedOptions = '';

      $('#quick-view ul>li').each(function (i) {

        if (selectedOptions == '') {

          selectedOptions = $(this).val();

        } else {

          selectedOptions = selectedOptions + ' / ' + $(this).val();

        }

      });

      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {

            var price = parseFloat(v.price / 100).toFixed(2);

            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

            var v_qty = v.inventory_quantity;

            var v_inv = v.inventory_management;

            $('.qv-product-price').text('$' + price);

            $('.qv-product-original-price').text('$' + original_price);

            if (v_inv == null) {

              $('.qv-add-button').prop('disabled', false).val('Add to Cart');

            } else {

              if (v.inventory_quantity < 1) {

                $('.qv-add-button').prop('disabled', true).val('Sold Out');

              } else {

                $('.qv-add-button').prop('disabled', false).val('Add to Cart');

              }

            }

          }

        });

      });

    });
    $.fancybox({

      href: '#quick-view',

      maxWidth: 1040,

      maxHeight: 600,

      fitToView: true,

      width: '75%',

      height: '70%',

      autoSize: false,

      closeClick: false,

      openEffect: 'none',

      closeEffect: 'none',

      'beforeLoad': function () {

        var product_handle = $('#quick-view').attr('class');
         //--------------------
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
         var qty = $('.qv-quantity').val();

          var selectedOptions = '';

          var var_id = '';

          $('#quick-view ul').each(function (i) {

            if (selectedOptions == '') {

              selectedOptions = $(this).val();

            } else {

              selectedOptions = selectedOptions + ' / ' + $(this).val();

            }

          });
            $(product.variants).each(function (i, v) {

               if (v.title == selectedOptions) {

                var_id = v.id;
                 
                processCart(var_id);

               }

            });

          });
          function processCart(var_id) {
        //  console.log("var_id::var_idvar_idvar_id::",var_id);
          $('.addTocart_submit>input[type="hidden"]').attr("value",var_id);
          }
          $('body').on('click', '.addTocart', function (e) {
            e.preventDefault();
            var btn = $(this);
            $('operror').remove();
            var number =  $('.addTocart_submit [name="id"]').val()
            var form = $(this).parents('.addTocart_submit').serialize();
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: form,
                dataType: "json",
               success:function(data){
          console.log('succ -- ')
                  $(`[v_id="${number}"]`).addClass('active-size')
                 $(`[v_id="${number}"]`).siblings().removeClass('active-size')
      $.ajax({url: "/cart?section_id=mini-cart", 
        success: function(result) {
        var successHtml = $($.parseHTML(result)).find("#sidebar-cart").html();
          $("#sidebar-cart").html(successHtml);
            $(`.Header__CartDot`).trigger('click');
          }});    
      $.getJSON("/cart.js",function (c) {
        document.querySelector('span.Header__CartDot').classList.add('is-visible')
              $('.Header__CartCount').text(c.item_count);
              $('.Header__CartCount').text(c.item_count);         
          });
                 $(`[v_id="${number}"]`).addClass('active-size')
        },
                error: function (jqXHR, textStatus, erorThrown) {
                   $('.qv-add-button').prop('disabled', true).val('Sold Out');
                }
            })
         setTimeout(()=>{
    $.ajax({url: "/cart?section_id=mini-cart", 
                  success: function(result) {
                    var successHtml = $($.parseHTML(result)).find("#sidebar-cart").html();
          $("#sidebar-cart").html(successHtml);
          }});
           
},4000)     
 
          });
          function addToCartSuccess() {
           
          // $("div#sidebar-cart").attr("aria-hidden","false");
          // $("div#sidebar-cart").attr("tabindex","-1");
          // $(".PageOverlay").addClass("is-visible");
            
          // $.get('/cart', function (data) {
          // $('.main-cart-drawer').addClass('show-cart');
          //   $('.CartItemWrapper').html(data);
          //  console.log("data:::::::::::::::::::::::::::::::::::::",data)
          // })           
          }     

        // });

        $('.fancybox-wrap').css('overflow', 'hidden !important');

      },

      'afterShow': function () {

        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {

          $('.qv-product-images').addClass('loaded');

        });

      },

      'afterClose': function () {

        $('#quick-view').removeClass().empty();

      }

    });

   
  //  quantity button
// review and retings
  $('h5.qv-product-price').css('display','none')
  $('h5.qv-product-original-price').css('display','none')
 setTimeout(()=>{
$('.review-json-fetch').append($(`[data-handle="${product_handle}"]`).parents('.varient-des').siblings('.ProductItem__Info').children().find('.jdgm-prev-badge').html())
if(window.page_type == 'index'){ 
$('h5.qv-product-price').text($(`[data-handle="${product_handle}"]`).parents('.varient-des').siblings('.ProductItem__Info').children('.ProductItem__PriceList').children().eq(0).text())
$('h5.qv-product-original-price').text($(`[data-handle="${product_handle}"]`).parents('.varient-des').siblings('.ProductItem__Info').children('.ProductItem__PriceList').children().eq(1).text())
}
     if(window.page_type == 'search'){
$('h5.qv-product-price').text($(`[data-handle="${product_handle}"]`).parents('div.ProductItem').children('.ProductItem__Info').children('.ProductItem__PriceList').children().eq(0).text())
$('h5.qv-product-original-price').text($(`[data-handle="${product_handle}"]`).parents('div.ProductItem').children('.ProductItem__Info').children('.ProductItem__PriceList').children().eq(1).text())
var review = $(`[data-handle="${product_handle}"]`).parents('.ProductItem').children().find('.jdgm-prev-badge__text').text()
$('.review-json-fetch').append($(`[data-handle="${product_handle}"]`).parents('.ProductItem').children().find('.jdgm-prev-badge__stars').html()+ " "+review)
   $('[salebages]').append($(`[data-handle="${product_handle}"]`).parents('div.ProductItem').children('.ProductItem__LabelList').html())
 
       setTimeout(()=>{
$(".jdgm-prev-badge[data-average-rating='0.00']").css('display','block !important')
    },1000)
}

if(window.page_type == 'collection'){  
$('h5.qv-product-price').text($(`[data-handle="${product_handle}"]`).parents('div.ProductItem').children('.ProductItem__Info').children('.ProductItem__PriceList').children().eq(0).text())
$('h5.qv-product-original-price').text($(`[data-handle="${product_handle}"]`).parents('div.ProductItem').children('.ProductItem__Info').children('.ProductItem__PriceList').children().eq(1).text())
$('.review-json-fetch').append($(`[data-handle="${product_handle}"]`).parents('.varient-des').siblings('.ProductItem__Info').children('.ProductItem__Rating.Heading').html())
var review = $(`[data-handle="${product_handle}"]`).parents('.ProductItem').children().find('.jdgm-prev-badge__text').text()
$('.review-json-fetch').append($(`[data-handle="${product_handle}"]`).parents('.ProductItem').children().find('.jdgm-prev-badge__stars').html()+ " "+review)
   $('[salebages]').append($(`[data-handle="${product_handle}"]`).parents('div.ProductItem').children('.ProductItem__LabelList').html())
 
  setTimeout(()=>{
$(".jdgm-prev-badge[data-average-rating='0.00']").css('display','block !important')
    },1000)
}
   $('[salebages]').append($(`[data-handle="${product_handle}"]`).parents('div.ProductItem').children().find('.ProductItem__LabelList').html())
   $('h5.qv-product-price').css('display','block')
  $('h5.qv-product-original-price').css('display','block')
 },1500)   


$('.qv-content .addTocart_submit [name="id"]').val(data__get_handel.getAttribute('quick-node-js'))

setTimeout(()=>{
  $('[v_available]').each(function(i,o){
    
  if($(o).attr('v_available') != 'false'){ 
      console.log($(o).attr('v_id'))
  $('.addTocart_submit [name="id"]').val($(o).attr('v_id'))
     $('[plusbtn]').attr('v_available_q',$(o).attr('v_available'))
      $('[quantity_qc]').attr('v_available_q',$(o).attr('v_available'))
      $('[minusbtn]').attr('v_available_q',$(o).attr('v_available'))
  return false;
  }else{
  $('.addTocart_submit [name="id"]').val($(o).attr('v_id'))
 } 

})
// console.log(quick_node_js)
    $(`[quick-node-js|="${quick_node_js}"]`).parents('.swatich-list').children('.swatics').find('li').each(function(i,o){
       $(o).attr('class').split('/')[1] 
        $('[v_available]').each(function(i,p){ 
           // console.log($(o).text().trim())
   if($(o).text().trim() == $(p).text()){
     //  console.log($(p).text())
  $(p).attr('qty_js_q', $(o).attr('class').split('/')[1] )
 } 

})
 })
 $('[v_available="true"]').eq(0).addClass('active-size')
  
 
},2000) 

 setTimeout(()=>{ 
  var get_q =  $('.active-size[v_available]').val()
   $('[quantity_qc]').attr('quantity_f',get_q)
 var add_qty =   $('[v_available="true"]').eq(0).attr('qty_js_q')
    $('[quantity_qc]').attr('quantity_f',add_qty)
 $('[quantity_qc]').attr('quick_jcc',node_qtty_js_x)
   
},3000)   
};

 

$(window).resize(function () {

  if ($('#quick-view').is(':visible')) {

   $('.qv-product-images').slick('setPosition');
  }
});
 